import {registerDashboard} from "../../../../common/utils";
import SalesOperationsDashboardSrcAggregated from "../index";
import {raSurplusMmsDashboardDefinition} from "../dashboardDefinition";


registerDashboard(raSurplusMmsDashboardDefinition);  // This is a function that registers the dashboard definition to the dashboard list
// this will allow the dashboard to be managed by permission management.


export default function SurplusMmsSrcAggregated({ title = "Sales Dashboard", defaultTab = 'sales' }) {
    return <SalesOperationsDashboardSrcAggregated title={title} defaultTab={defaultTab} dashboardDefinition={raSurplusMmsDashboardDefinition}/>
}

